const translation = {
  custom: '定制',
  upgradeTip: {
    prefix: '升级您的计划以',
    suffix: '定制您的品牌。',
  },
  webapp: {
    title: '定制 WebApp 品牌',
    removeBrand: '移除 Powered by Dify',
    changeLogo: '更改 Powered by Brand 图片',
    changeLogoTip: 'SVG 或 PNG 格式，最小尺寸为 40x40px',
  },
  app: {
    title: '定制应用品牌',
    changeLogoTip: 'SVG 或 PNG 格式，最小尺寸为 80x80px',
  },
  upload: '上传',
  uploading: '上传中',
  uploadedFail: '图片上传失败，请重新上传。',
  change: '更改',
  apply: '应用',
  restore: '恢复默认',
  customize: {
    contactUs: '联系我们',
    prefix: '如需在 Dify 内自定义品牌图标，请',
    suffix: '升级至企业版。',
  },
}

export default translation
